import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { AppProvider } from './context/AppContext';

import Login from './components/Auth/Login';
import CompleteRegistration from './components/Auth/CompleteRegistration';
import LandingPage from './components/Landing/LandingPage';
import CultivationGuide from './components/CultivationGuide/CultivationGuide';
import BuyController from './components/Buy/BuyController';
import Dashboard from './components/Dashboard/Dashboard';
import Plants from './components/Plants/PlantList';
import PlantDetail from './components/Plants/PlantDetail';
import PlantHistory from './components/Plants/PlantHistory';
import Settings from './components/Settings/Settings';
import Account from './components/Settings/Account';
import Navbar from './components/Common/Navbar';
import PrivateRoute from './components/Common/PrivateRoute';

const theme = createTheme({
    palette: {
        mode: 'dark',
        primary: { main: '#4CAF50' },
        secondary: { main: '#2196F3' },
        background: { default: '#121212', paper: '#1E1E1E' }
    },
    typography: { fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif' }
});

function App() {
    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <AppProvider>
                <Router>
                    <ScrollToTop />
                    <div className="App">
                        <Toaster position="top-right" />
                        <Routes>
                            <Route path="/" element={<LandingPage />} />
                            <Route path="/guia" element={<CultivationGuide />} />
                            <Route path="/comprar" element={<BuyController />} />
                            <Route path="/login" element={<Login />} />
                            <Route path="/complete-registration" element={<CompleteRegistration />} />
                            <Route path="/*" element={
                                <PrivateRoute>
                                    <Navbar />
                                    <Routes>
                                        <Route path="/dashboard" element={<Dashboard />} />
                                        <Route path="/plants" element={<Plants />} />
                                        <Route path="/plants/:id" element={<PlantDetail />} />
                                        <Route path="/history" element={<PlantHistory />} />
                                        <Route path="/settings" element={<Settings />} />
                                        <Route path="/account" element={<Account />} />
                                        <Route path="*" element={<Navigate to="/dashboard" />} />
                                    </Routes>
                                </PrivateRoute>
                            } />
                        </Routes>
                    </div>
                </Router>
            </AppProvider>
        </ThemeProvider>
    );
}

function ScrollToTop() {
    const { pathname } = useLocation();

    React.useEffect(() => {
        window.history.scrollRestoration = 'manual';
        window.scrollTo(0, 0);
    }, [pathname]);

    return null;
}

export default App;
